import { render, staticRenderFns } from "./ChartSmall.vue?vue&type=template&id=35c6b179&"
import script from "./ChartSmall.vue?vue&type=script&lang=js&"
export * from "./ChartSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports